import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/styles.css';
import { getCompanies, deleteCompany } from '../services/api';
import { useServerPagination } from '../utils/serverPag';
import { confirmar } from './ConfirmModal';
import { toast } from 'react-toastify';

const Empresas = () => {
  const {
    items: empresas,
    page,
    total,
    totalPages,
    loading,
    error,
    setPage,
    refresh
  } = useServerPagination(getCompanies, { initialPerPage: 20 });

  const handleEliminarEmpresa = async (empresaId, nombreLegal) => {
    if (await confirmar(`¿Está seguro que quiere eliminar la empresa "${nombreLegal}"?`, { variante: 'peligro' })) {
      try {
        await deleteCompany(empresaId);
        toast.success(`Empresa "${nombreLegal}" eliminada correctamente`);
        refresh(); // recarga la página actual
      } catch (error) {
        console.error('Error al eliminar la empresa:', error);
        toast.error('No se pudo eliminar la empresa.');
      }
    }
  };

  return (
    <div className="content-wrapper">
      <h1>Listado de Empresas</h1>
      {loading && <div>Loading empresas...</div>}
      {error && <div className="error">Error cargando empresas</div>}
      <div className="container">
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Nombre Legal</th>
                <th>Ciudad</th>
                <th>Correo</th>
                <th>Teléfono</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {empresas.map((empresa) => (
                <tr key={empresa.id_usuario}>
                  <td>{empresa.nombre_legal}</td>
                  <td>{empresa.ciudad}</td>
                  <td>{empresa.email}</td>
                  <td>{empresa.telefono_principal ?? 'Sin teléfono'}</td>
                  <td>
                    <div className="btn-group" style={{ flexDirection: 'column' }}>
                      <Link
                        to={`/empresas/editar/${empresa.id_usuario}`}
                        className="btn-create"
                      >
                        Editar Empresa
                      </Link>
                      <Link
                        to={`/empresas/${empresa.id_usuario}`}
                        className="btn-secondary"
                      >
                        Ver Detalles
                      </Link>
                      <button
                        type="button"
                        className="btn-danger"
                        onClick={() => handleEliminarEmpresa(empresa.id_usuario, empresa.nombre_legal)}
                      >
                        Eliminar
                      </button>
                    </div>
                  </td>

                </tr>
              ))}
              {empresas.length === 0 && !loading && (
                <tr>
                  <td colSpan={5} style={{ textAlign: 'center' }}>No hay empresas en esta página.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="pagination-controls">
          <button onClick={() => setPage(page - 1)} disabled={page <= 1 || loading}>Prev</button>
          <span> Página {page} de {totalPages} — {total} empresas</span>
          <button onClick={() => setPage(page + 1)} disabled={page >= totalPages || loading}>Next</button>
        </div>

      </div>
      <br />
      <Link to="/empresas/crear" className="btn btn-submit">
        Crear Empresa
      </Link>
    </div>
  );
};

export default Empresas;
